import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import store from './store/store';
import { Provider } from "react-redux";
import App from './components/App/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router basename='/forms'>
      <App />
    </Router>
  </Provider>
);
